import * as React from "react";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { useResultsContext } from "../Spirometry/UseResultsContext";
import { TestResults } from "./PFTAPITypes";
import { ResultsGroupHeading } from "./ResultsGroupHeading";

export interface TestAcceptabilityTableProps {
    displayTechnicianAcceptability: boolean;
    isViewOnly: boolean;
    isLoading: boolean;
    testResults: Array<TestResults>;
    onAcceptabilityChange: (testId: string, checked: boolean) => void;
}

export const TestAcceptabilityTable = ({ displayTechnicianAcceptability, isViewOnly, isLoading, testResults, onAcceptabilityChange }: TestAcceptabilityTableProps) => {
    const { additionalColumnCount } = useResultsContext();

    return (
        <>
            <ResultsGroupHeading resultsCount={testResults.length} title="Acceptability" />
            <tr>
                <td>Acceptable</td>
                {
                    testResults.map((tr) => {
                        return (
                            <td key={`OverreaderAcceptability${tr.TestId}`}>
                                <input disabled={isViewOnly}
                                    checked={tr.OverreaderAcceptability}
                                    data-automationid={`test-acceptability-overread-${tr.TestNumber}`}
                                    type="checkbox"
                                    onChange={(e) => onAcceptabilityChange(tr.TestId, e.target.checked)}
                                />
                            </td>
                        );
                    })
                }
                <td colSpan={additionalColumnCount - 1 }></td>
            </tr>
            {displayTechnicianAcceptability ? <tr>
                <td>Technician Acceptability</td>
                {
                    testResults.map((tr) => {
                        return (
                            <td key={`TechnicianAcceptability${tr.TestId}`}>
                                <input disabled={true} readOnly={true}
                                    checked={tr.TechnicianAcceptability}
                                    data-automationid={`test-acceptability-technician-${tr.TestNumber}`}
                                    type="checkbox"
                                />
                            </td>
                        );
                    })
                }
                <td colSpan={additionalColumnCount - 1}></td>
            </tr> : null}

        </>
    );
}
